import { ReactNode } from 'react'

interface ContainerPageProps {
    children: ReactNode
    className?: string
}

export const ContainerPage = ({
    children,
    className
}: ContainerPageProps): JSX.Element => {
    return (
        <section
            className={`w-full min-h-screen bg-white flex items-center justify-center ${className}`}
        >
            {children}
        </section>
    )
}
